import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import { post, patch } from '../libs/axios.js'
import router from '@/router'
import permission from './permission.js'
import common from '@/libs/util.js'
import { Message } from 'view-design'

Vue.use(Vuex)

const state = {
  isCollapsed: false,
  platform: 'lawyer',
  menuList: [],
  currentUser: {
    username: '',
    UserRefreshToken: '',
    UserToken: ''
  },
  tagMenuArr: [],
  tagMenuPathArr: [],
  wechatInfo: {
    code: '',
    state: ''
  },
  hasInfo: false

}

const mutations = {
  toggleCollapsed(state, isCollapsed) {
    state.isCollapsed = isCollapsed
  },
  changeMenu(state, menuList) {
    state.menuList = menuList
  },
  openTagMenu(state, obj) {
    state.tagMenuArr = obj.tagMenuArr
    state.tagMenuPathArr = obj.tagMenuPathArr
  },
  setWeChatInfo(state, info) {
    state.wechatInfo = info
  },
  setHasInfo(state, bool) {
    state.hasInfo = bool
  }
}
const actions = {
  setWeChatInfo({ commit }, info) {
    commit('setWeChatInfo', info)
  },
  async getAccessToken({ commit }, info) {
    const unionId = await common.getUnionId(info.code, info.state)
    const url = '/authentication/auth/loginWechat'
    const ajaxData = {
      unionId: unionId,
      providerId: 'wechat',
      grantType: 'password'
    }
    post(url, ajaxData).then(res => {
      if (res.code == 0) {
        window.localStorage.setItem('token', res.data.accessToken)
        window.localStorage.setItem('refreshToken', res.data.refreshToken)
        window.localStorage.setItem('expiryTime', new Date().getTime())
        window.localStorage.setItem('account', JSON.stringify(res.data.additionalInformation.account))
        window.localStorage.setItem('pauseState', res.data.additionalInformation.currentUser && res.data.additionalInformation.currentUser.pauseState) // 用户状态
        router.push({ path: '/' })
      } else if (res.code == 10005) {
        router.push({ path: '/login', query: { unionId: unionId }})
      } else {
        Message.error(res.message)
      }
    })
  }
}

const getters = {
  toggleCollapsed(state) {
    return state.isCollapsed
  },
  changeMenu(state) {
    return state.menuList
  },
  openTagMenu(state) {
    return state
  },
  tagMenuPathArr: state => state.tagMenuPathArr
}

var vuexStore = new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
  modules: { permission: permission, user }
})

export default vuexStore



// WEBPACK FOOTER //
// ./src/store/index.js